import { logger } from './logger';

export const onQueryError = (error: unknown) => {
  logger.error(
    '[ReactQuery] Query failed',
    error instanceof Error ? error : new Error(String(error))
  );
};

export const onMutationError = (error: unknown) => {
  logger.error(
    '[ReactQuery:Mutation] Mutation failed',
    error instanceof Error ? error : new Error(String(error))
  );
};
